exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-pie.js
// module id = 47
// module chunks = 2